// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import styled from 'styled-components'

export const Display = styled.div<{
  $isCollapsed: boolean
  $isFullScreen?: boolean
}>`
  display: flex;
  flex-direction: column;
  flex: auto;
  height: 100%;
  overflow: hidden;
  width: ${({ $isCollapsed, $isFullScreen }) =>
    $isCollapsed && !$isFullScreen ? 'calc(100% - 100px)' : 'auto'};
`

export const Content = styled.main<{
  $isFullScreen?: boolean
}>`
  position: relative;
  flex: auto;
  overflow: auto;
  padding: ${(props) => (props.$isFullScreen ? '0;' : '24px 24px 0;')}
  transition: width 300ms ease-in-out;
  height: 100%;
`
